import { useLanguage } from "../../context/LanguageContext";

const TranslateTabBar = ({ activeTab, onTabChange, inline = false }) => {
  const { t } = useLanguage();

  const TABS = [
    { key: "ai-chat", label: t.aiChat },
    { key: "translate", label: t.translate },
    { key: "transcribe", label: t.transcribe },
  ];

  return (
    <div className={`${inline ? "flex-none" : "flex justify-center mb-4"}`}>
      <div className={`flex items-center border-[3px] border-tab-border rounded-[29px] h-[33.53px] ${inline ? "" : "w-full max-w-[331.69px]"}`}>
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => onTabChange(key)}
            className={`flex-1 h-full flex items-center justify-center rounded-[29px] text-[11px] lg:text-[13px] font-semibold font-roboto uppercase tracking-wide transition-all leading-none whitespace-nowrap px-2 sm:px-3 ${
              activeTab === key
                ? "border-[3px] border-tab-border bg-tab-border text-deep-purple"
                : "bg-transparent text-deep-purple border-[3px] border-transparent"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TranslateTabBar;
